import { useEffect, useRef } from "react";

import type { TurnEntry } from "../game/GameContext";
import { useGame } from "../game/GameContext";

export default function Output() {
  const { entries } = useGame();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [entries]);

  return (
    <div id="output" ref={ref}>
      {entries.map((e) => (
        <EntryView key={e.id} entry={e} />
      ))}
    </div>
  );
}

function EntryView({ entry }: { entry: TurnEntry }) {
  switch (entry.kind) {
    case "system":
      return <div className="system-message">{entry.text}</div>;
    case "error":
      return (
        <div className="turn">
          <div className="error">{entry.text}</div>
        </div>
      );
    case "narration":
      return (
        <div className="turn">
          <div className="narration">{entry.narration}</div>
        </div>
      );
    case "turn": {
      const narrationCls =
        "narration" + (entry.cached ? " cached" : "") + (entry.streaming ? " streaming" : "");
      return (
        <div className="turn">
          {entry.action && <div className="action">{entry.action}</div>}
          {(entry.narration || entry.streaming) && (
            <div className={narrationCls}>{entry.narration || ""}</div>
          )}
        </div>
      );
    }
    default: {
      // Exhaustiveness guard: adding a new TurnEntry kind without
      // updating this switch is now a compile-time type error.
      const _exhaustive: never = entry.kind;
      return null;
    }
  }
}
